import { toast } from './index.js';

export default {
  $didafe: {
    toast
  }
};
